export default __webpack_public_path__ + "static/media/stableVariableAPR.5c948dc3.svg";